var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MoleculesCmsUrlWrapper',_vm._b({class:[
    _vm.textColor(),
    'basic-banner',
    'gpt-slot',
    _vm.isSmallCard ? 'sm-cols-5' : 'sm-cols-6',
    ("lg-cols-" + (_vm.data.number_of_columns))
  ],style:(_vm.wrapperStyle),attrs:{"id":("gpt-ad-" + _vm.bannerId),"link":_vm.urlData}},'MoleculesCmsUrlWrapper',_vm.getDataAttributes(_vm.data),false),[_c('div',{staticClass:"in-image-container",class:{
      'v-center': true,
      'small-card': _vm.isSmallCard
    }},[(_vm.getField('title'))?_c('span',{staticClass:"h6"},[_vm._v("\n      "+_vm._s(_vm.getField('title'))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.getField('subtitle'))?_c('h3',{class:_vm.subtitleClass},[_vm._v("\n      "+_vm._s(_vm.getField('subtitle'))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.getField('button_text'))?_c('MoleculesCmsCustomButtonWrapper',{attrs:{"element":_vm.data},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var variant = ref.variant;
return [_c('AtomsKEButton',{attrs:{"variant":variant,"small":""}},[_vm._v("\n          "+_vm._s(_vm.getField('button_text'))+"\n        ")])]}}],null,false,3459350345)}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }